import axios from "axios";
import { url } from "./urls";
import { emitAuthExpired, getToken } from "./auth";

// Scoped axios instance — only this client carries auth + locale headers.
// Using a dedicated instance keeps third-party axios calls (if any are
// added later) free of our internal headers.
const apiClient = axios.create({
    baseURL: url,
    timeout: 60000, // 60s — Excel uploads can be slow
});

apiClient.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        const lang = localStorage.getItem("language") || "bs";
        config.headers["X-Locale"] = lang;
        config.headers["Accept-Language"] = lang;
        if (!config.headers["Accept"]) {
            config.headers["Accept"] = "application/json";
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let expiredFiring = false;
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        // 401 = invalid/missing token; 419 = session expired (Sanctum SPA mode).
        // Only react if we were actually authenticated — login attempts should
        // still surface their own error message instead of redirecting.
        if ((status === 401 || status === 419) && getToken() && !expiredFiring) {
            expiredFiring = true;
            emitAuthExpired();
            setTimeout(() => { expiredFiring = false; }, 1000);
        }
        return Promise.reject(error);
    }
);

export default apiClient;